export const SWITCH_HOME_SECTION_EVENT =
	'canvas-agent:switch:home-section';
export const SWITCH_SITE_SECTION_EVENT =
	'canvas-agent:switch:site-section';
export const SWITCH_FILTER_EVENT =
	'canvas-agent:switch:filter';
export const SWITCH_FOCUS_EVENT =
	'canvas-agent:switch:focus';
export const SWITCH_CREATE_MODAL_EVENT =
	'canvas-agent:switch:create-modal';
export const SWITCH_CONFIGURE_MODAL_EVENT =
	'canvas-agent:switch:configure-modal';
export const SWITCH_MOVE_MODAL_EVENT =
	'canvas-agent:switch:move-modal';
export const SWITCH_REBOOT_MODAL_EVENT =
	'canvas-agent:switch:reboot-modal';
export const SWITCH_DELETE_MODAL_EVENT =
	'canvas-agent:switch:delete-modal';
export const SWITCH_FACTORY_RESET_MODAL_EVENT =
	'canvas-agent:switch:factory-reset-modal';
export const SWITCH_PARTITION_MODAL_EVENT =
	'canvas-agent:switch:partition-modal';
export const SWITCH_CONTINUOUS_POE_MODAL_EVENT =
	'canvas-agent:switch:continuous-poe-modal';
export const SWITCH_DASHBOARD_SECTION_EVENT =
	'canvas-agent:switch:dashboard-section';
export const SWITCH_CONFIGURE_PORT_MODAL_EVENT =
	'canvas-agent:switch:configure-port-modal';
export const SWITCH_GLOBAL_VLANS_SECTION_EVENT =
	'canvas-agent:switch:global-vlans-section';
export const SWITCH_CREATE_VLAN_MODAL_EVENT =
	'canvas-agent:switch:create-vlan-modal';
export const SWITCH_DELETE_VLAN_MODAL_EVENT =
	'canvas-agent:switch:delete-vlan-modal';
export const SWITCH_BULK_SECTION_EVENT =
	'canvas-agent:switch:bulk-section';
